/* eslint-disable react-refresh/only-export-components */
import { Navigate, Outlet, Route } from 'react-router-dom';

import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import ComingSoon from '@/pages/provider/ComingSoon';
import { useProvider } from '@/hooks/useTenant';
import ProviderDashboard from '@/pages/provider/dashboard';
import CustomersPage from '@/pages/provider/customers';
import CustomerDetailPage from '@/pages/provider/customers/[id]';
import SettingsPage from '@/pages/provider/settings';
import ProductList from '@/pages/provider/products';
import ProductDetail from '@/pages/provider/products/[id]';
import CustomerPreviewPage from '@/pages/provider/preview';

 
function ProviderBillingComingSoon() {
  const provider = useProvider();
  const name = provider?.name ?? 'your organization';
  return (
    <ComingSoon
      title={name + ' ' + 'Billing'}
      description={'Manage your ' + name + ' subscription'}
    />
  );
}

function ProviderRouteGuard() {
  return (
    <ProtectedRoute>
      <Outlet />
    </ProtectedRoute>
  );
}

export const providerRoutes = (
  <Route path="/provider" element={<ProviderRouteGuard />}>
    <Route index element={<Navigate to="dashboard" replace />} />
    <Route path="dashboard" element={<ProviderDashboard />} />
    <Route path="products" element={<ProductList />} />
    <Route path="products/new" element={<ComingSoon title="Create New Product" />} />
    <Route path="products/:id" element={<ProductDetail />} />
    <Route path="customers" element={<CustomersPage />} />
    <Route path="customers/:id" element={<CustomerDetailPage />} />
    <Route path="customers/invite" element={<ComingSoon title="Invite Customer" />} />
    <Route path="billing" element={<ComingSoon title="Customer Billing" description="Manage customer subscriptions and payments" />} />
    <Route path="billing/stripe" element={<ComingSoon title="Stripe Configuration" />} />
    <Route path="analytics" element={<ComingSoon title="Analytics" description="View detailed analytics and reports" />} />
    <Route path="analytics/revenue" element={<ComingSoon title="Revenue Analytics" />} />
    <Route path="analytics/usage" element={<ComingSoon title="Usage Analytics" />} />
    <Route path="docs" element={<ComingSoon title="Documentation" description="API documentation and guides" />} />
    <Route path="docs/getting-started" element={<ComingSoon title="Getting Started" />} />
    <Route path="preview" element={<CustomerPreviewPage />} />
    <Route path="florentin-billing" element={<ProviderBillingComingSoon />} />
    <Route path="settings" element={<SettingsPage />} />
    <Route path="settings/profile" element={<SettingsPage />} />
    <Route path="settings/organization" element={<SettingsPage />} />
    <Route path="help" element={<ComingSoon title="Help & Support" description="Get help and support" />} />
    <Route path="help/api-docs" element={<ComingSoon title="API Documentation" />} />
  </Route>
);
